import { createBrowserRouter, Navigate, RouterProvider } from "react-router";

// Import all page components
import LoginPage from "../../features/login/LoginPage";
import ResetPasswordPage from "../../features/login/ResetPasswordPage";
import SettingsPage from "../../features/settings/SettingsPage";
import SaveUserPage from "../../features/profile/SaveUserPage";
import ContactPage from "../../features/contact/ContactPage";
import OfficesPage from "../../features/settings/Offices/OfficesPage";
import SaveOfficePage from "../../features/settings/Offices/SaveOfficePage";
import GroupsPage from "../../features/settings/Groups/GroupsPage";
import UsersPage from "../../features/settings/Users/UsersPage";
import SaveGroupPage from "../../features/settings/Groups/SaveGroupPage";
import CountriesPage from "../../features/settings/Countries/CountriesPage";
import SaveCountry from "../../features/settings/Countries/SaveCountry";
import CustomizePage from "../../features/settings/Customize/CustomizePage";
import AuditTrailPage from "../../features/settings/AuditTrail/AuditTrailPage";
import IntegrationsPage from "../../features/settings/Integrations/IntegrationsPage";
import ImportPage from "../../features/settings/Import/ImportPage";
import BulkSyncPage from "../../features/admin/BulkSync/BulkSyncPage";
import ClearCachePage from "../../features/admin/ClearCache/ClearCachePage";
import P24MatchPage from "../../features/admin/P24RefMapping/P24MatchPage";
import P24AreaMapPage from "../../features/admin/P24AreaMapping/P24AreaMapPage";
import AreaTransferPage from "../../features/admin/AreaTransfer/AreaTransferPage";
import UserTransferPage from "../../features/admin/UserTransfer/UserTransferPage";
import ReportsPage from "../../features/admin/Reports/ReportsPage";
import SaveBrochurePage from "../../features/admin/Reports/SaveBrochurePage";
import MapAreaToolPage from "../../features/admin/MapArea/MapAreaToolPage";
import CreditPage from "../../features/admin/AgentMsgCredit/CreditPage";
import SyncIssuesPage from "../../features/admin/SyncIssues/SyncIssuesPage";
import SaveReportPage from "../../features/admin/Reports/SaveReportPage";
import PropertyPage from "../../features/property/PropertyPage";
import LibraryPage from "../../features/library/LibraryPage";
import TestComponent from "../../features/TestComponent";
import SaveContactPage from "../../features/contact/SaveContactPage";
import SaveContentPage from "../../features/library/SaveContentPage";
import SavePropertyPage from "../../features/property/SavePropertyPage";
import DashboardPage from "../../features/home/DashboardPage";
import FlexPropertySyncDBox from "../../features/settings/FlexSyncDBox/FlexPropertySyncDBox";
import FlexAgentSyncDBox from "../../features/settings/FlexSyncDBox/FlexAgentSyncDBox";
import SaveIntegrationsPage from "../../features/settings/Integrations/SaveIntegrationsPage";
import ImportPropertiesPage from "../../features/settings/Import/ImportPropertiesPage";
import SaveProperty from "../../features/settings/Import/SaveProperty";
import LoopPage from "../../features/deal/LoopPage";
import DealPage from "../../features/deal/dealPages/DealPage";
import CommissionSlipPage from "../../features/settings/CommissionSlip/CommissionSlipPage";
import SaveCommissionSlipPage from "../../features/settings/CommissionSlip/SaveCommissionSlipPage";
import AuthCodePage from "../../features/login/AuthCodePage";
import ResetTwoFAPage from "../../features/login/ResetTwoFAPage";
import OfficeDealGridPage from "../../features/settings/Offices/OfficeDealGridPage";
import NotFound from "../../features/home/error/NotFound";
import ServerErrorPage from "../../features/home/error/ServerErrorPage";
import UnauthorizedPage from "../../features/home/error/UnauthorizedPage";
import ErrorPage from "../../features/home/error/ErrorPage";
import OfficeInsightsPage from "../../features/settings/Offices/OfficeInsightsUsage/OfficeInsightsPage";
import ChangeP24ReferenceAjax from "../../features/admin/P24RefUpdate/P24RefUpdate";
import ProtectedRoute from "@/app/layout/ProtectedRoute";
import LoggedIn from "@/app/layout/LoggedIn";
import PublicListingPage from "@/features/public/PublicListingPage";

const router = createBrowserRouter([
  {
    path: "/shared/:id",
    element: <PublicListingPage />,
  },
  {
    element: (
      <ProtectedRoute>
        <LoggedIn />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/",
        element: <DashboardPage />,
      },
      {
        path: "/home",
        element: <DashboardPage />,
      },
      {
        path: "/home/index",
        element: <DashboardPage />,
      },
      {
        path: "/settings",
        element: <SettingsPage />,
      },
      {
        path: "/settings/saveuser/:userId",
        element: <SaveUserPage />,
      },
      {
        path: "/contacts/saveContact",
        element: <SaveContactPage />,
      },
      {
        path: "/contacts",
        element: <ContactPage />,
      },
      {
        path: "/settings/users",
        element: <UsersPage />,
      },
      {
        path: "/settings/saveuser",
        element: <SaveUserPage />,
      },
      {
        path: "/settings/offices",
        element: <OfficesPage />,
      },
      {
        path: "/settings/saveoffice",
        element: <SaveOfficePage />,
      },
      {
        path: "/settings/groups",
        element: <GroupsPage />,
      },
      {
        path: "/settings/saveGroup",
        element: <SaveGroupPage />,
      },
      {
        path: "/settings/countries",
        element: <CountriesPage />,
      },
      {
        path: "/settings/saveCountry",
        element: <SaveCountry />,
      },
      {
        path: "/settings/customize",
        element: <CustomizePage />,
      },
      {
        path: "/settings/auditTrail",
        element: <AuditTrailPage />,
      },
      {
        path: "/settings/integrations",
        element: <IntegrationsPage />,
      },
      {
        path: "/import/index",
        element: <ImportPage />,
      },
      {
        path: "/admin/bulkSync",
        element: <BulkSyncPage />,
      },
      {
        path: "/admin/clearCache",
        element: <ClearCachePage />,
      },
      {
        path: "/admin/p24Match",
        element: <P24MatchPage />,
      },
      {
        path: "/admin/p24AreaMap",
        element: <P24AreaMapPage />,
      },
      {
        path: "/admin/areaTransfer",
        element: <AreaTransferPage />,
      },
      {
        path: "/admin/userTransfer",
        element: <UserTransferPage />,
      },
      {
        path: "/admin/reports",
        element: <ReportsPage />,
      },
      {
        path: "/admin/saveBrochure",
        element: <SaveBrochurePage />,
      },
      {
        path: "/admin/saveReport",
        element: <SaveReportPage />,
      },
      {
        path: "/admin/mapAreaTool",
        element: <MapAreaToolPage />,
      },
      {
        path: "/admin/credit",
        element: <CreditPage />,
      },
      {
        path: "/admin/syncIssues",
        element: <SyncIssuesPage />,
      },
      {
        path: "/Property",
        element: <PropertyPage />,
      },
      {
        path: "/library",
        element: <LibraryPage />,
      },
      {
        path: "/library/saveContent",
        element: <SaveContentPage />,
      },
      {
        path: "/Property/SaveProperty",
        element: <SavePropertyPage />,
      },
      {
        path: "/Admin/FlexPropertySyncD",
        element: <FlexPropertySyncDBox />,
      },
      {
        path: "/Admin/FlexAgentSyncD",
        element: <FlexAgentSyncDBox />,
      },
      {
        path: "/settings/saveIntegration",
        element: <SaveIntegrationsPage />,
      },
      {
        path: "/import/properties",
        element: <ImportPropertiesPage />,
      },
      {
        path: "/import/saveProperty",
        element: <SaveProperty />,
      },
      {
        path: "/deal/saveDeal",
        element: <DealPage />,
      },
      {
        path: "/deal",
        element: <LoopPage />,
      },
      {
        path: "/Admin/CommissionSlip",
        element: <CommissionSlipPage />,
      },
      {
        path: "/Admin/SaveCommissionSlip",
        element: <SaveCommissionSlipPage />,
      },
      {
        path: "/Admin/OfficeDealGrid",
        element: <OfficeDealGridPage />,
      },
      {
        path: "/Admin/InsightsUsage",
        element: <OfficeInsightsPage />,
      },
      {
        path: "/Home/Unauthorized",
        element: <UnauthorizedPage />,
      },

      {
        path: "/admin/ChangeP24Reference",
        element: <ChangeP24ReferenceAjax />,
      },
      {
        path: "/server-error",
        element: <ServerErrorPage />,
      },
      {
        path: "/uncatch-error",
        element: <ErrorPage />,
      },
      {
        path: "/not-found",
        element: <NotFound />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
    errorElement: <Navigate to="/uncatch-error" />,
  },
  {
    element: <ProtectedRoute invert />,
    children: [
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/authcode",
        element: <AuthCodePage />,
      },
      {
        path: "/reset/:token",
        element: <ResetPasswordPage />,
      },
      {
        path: "/resetTwoFA/:token",
        element: <ResetTwoFAPage />,
      },
    ],
    errorElement: <Navigate to="/uncatch-error" />,
  },
]);

export const Router = () => {
  return <RouterProvider router={router} />;
};
